// src/App.js
import React from 'react';
import Index from './routes/index';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
    <Index />
    <ToastContainer />
    </>
  );

}

export default App;